import React, { useState } from 'react';
import { 
  Box, 
  IconButton,
  styled,
  CircularProgress
} from '@mui/material';
import Loading from '../components/Loading';
import { Helmet } from 'react-helmet';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import BMCPdf from '../assets/BMC.pdf';

// Styled components
const PDFContainer = styled(Box)(({ theme, fullscreen }) => ({
  backgroundColor: '#000',
  minHeight: '100vh',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: fullscreen ? '100vh' : 'calc(100vh - 40px)',
  position: fullscreen ? 'fixed' : 'relative',
  top: 0,
  left: 0,
  zIndex: fullscreen ? 9999 : 'auto',
  backgroundColor: '#fff',
  padding: '0',
  boxSizing: 'border-box',
  overflow: 'hidden'
}));

const ControlsContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '10px',
  right: '10px',
  zIndex: 1000,
  backgroundColor: 'rgba(0,0,0,0.5)',
  borderRadius: '4px',
  padding: '5px'
}));

const PDFFrame = styled('iframe')(({ theme }) => ({
  width: '100%',
  height: '100%',
  border: 'none'
}));

const LoaderContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#fff'
}));

const BMC = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [loading, setLoading] = useState(true);
  
  const toggleFullscreen = () => setIsFullscreen(!isFullscreen);
  
  const handleLoad = () => {
    setLoading(false);
  };

  return (
    <Box sx={{ height: '100vh', overflow: 'hidden' }}>
      <Helmet>
        <title>Warrili - Business Model Canvas</title>
        <meta name="description" content="Warrili's Business Model Canvas - Our strategic management template" />
        <meta name="keywords" content="business model canvas, Warrili, strategy, business model" />
      </Helmet>
      
      <PDFContainer fullscreen={isFullscreen}>
        {loading && (
          <LoaderContainer>
            <Loading overlay={true} />
          </LoaderContainer>
        )}
        
        <PDFFrame 
          src={BMCPdf} 
          title="Business Model Canvas"
          onLoad={handleLoad}
        />
        
        <ControlsContainer>
          <IconButton 
            onClick={toggleFullscreen}
            sx={{ color: '#fff' }}
          >
            {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>
        </ControlsContainer>
      </PDFContainer>
    </Box>
  );
};

export default BMC;